import React, { Fragment } from "react";
import "../documentation.css";
// import { formatTimestamp } from "../helpers";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { TodoIcon } from "../../assets/Icons";
import { formatTimestamp } from "../helpers";
import CandImage from "../Components/CandImage";

const PecanDeluxe = ({
  candidates,
  getReadingListPdf,
  downloadRef,
  images,
  handleOverlay,
  passImage
}) => {
  console.log("images in pecan comp");
  console.log(candidates);
  /**
   * Make call to profile 5 to retrieve desired file for Pecan Deluxe
   * @param {String} candidate
   * @param {String} typeCode
   * @param {String} filename
   * @param {String} contentType
   * @param {String} fileExt
   */
  const handleDownloadReadingList = (
    candidate,
    typeCode,
    filename,
    contentType,
    fileExt
  ) => {
    getReadingListPdf(
      candidate.candidateRef,
      candidate.firstName,
      candidate.lastName,
      typeCode,
      filename,
      contentType,
      fileExt
    );
  };

  /**
   *  Mapping of file typecode to file ext
   */
  const typeCodeToExt = new Map();
  typeCodeToExt
    .set("YPDC", ".pdf") // Contract for services, .pdf
    .set("YREU", ".pdf") // Settled Status - EU Settlement Scheme , .pdf (does not come from Profile5 - added by consultant direct to candidates profile)
    .set("YREP", ".pdf") // Pre-Settled Status - EU Settlement Scheme, .pdf (does not come from Profile5 - added by consultant direct to candidates profile)
    .set("JPPT", ".jpg") // Front of passport for RTW, .jpg
    .set("JPVI", ".jpg") // Visa front for RTW, .jpg
    .set("JPVB", ".jpg") // Visa back for RTW, .jpg
    .set("JPID", ".jpg") // Front of ID for RTW, .jpg
    .set("JPPB", ".jpg") // back of ID for RTW, .jpg
    .set("JBIR", ".jpg") // birth certficate, .jpg
    .set("JPNI", ".jpg") // Back of passport for RTW, .jpg
    .set("WRTV", ".docx") // Verfiication RTW, .docx
    .set("YXP", ".pdf") // Share Code Check Perm, .pdf
    .set("YXT", ".pdf") // Share Code Check Temp, .pdf
    .set("YRTW", ".pdf"); // Right to Work Approved, .pdf

  /**
   *  File types requested by Pecan Deluxe.
   */
  const PECAN_TYPE_CODES = [
    "YPDC", // Contract for services, .pdf
    "YREU", // Settled Status - EU Settlement Scheme
    "YREP", // Pre-Settled Status - EU Settlement Scheme
    "JPPT", // Front of passport for RTW, .jpg
    "JPVI", // Visa front for RTW, .jpg
    "JPVB", // Visa back for RTW, .jpg
    "JPID", // Front of ID for RTW, .jpg
    "JPPB", // back of ID for RTW, .jpg
    "JBIR", // birth certficate, .jpg
    "JPNI", // Back of passport for RTW, .jpg
    "WRTV", // Verfiication RTW, .docx
    "YXP", // Share Code Check Perm, .pdf
    "YXT", // Share Code Check Temp, .pdf
    "YRTW" // Right to Work Approved, .pdf
  ];

  /**
   * Returns whether the date created from the supplied string is actually a valid date.
   * see -> https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript?page=1&tab=scoredesc#tab-top
   * @param {String} dateStr
   * @returns {Boolean}
   */
  const isDate = dateStr =>
    new Date(dateStr) instanceof Date && !isNaN(new Date(dateStr));

  const isRead = candidate =>
    candidate.documents &&
    candidate.documents.readings &&
    candidate.documents.readings[PECAN_TYPE_CODES[0]] ? (
      <div className="tooltip">
        <button
          onClick={() =>
            handleDownloadReadingList(
              candidate,
              "YPDC",
              `PECAN Induction`,
              "application/pdf",
              "pdf"
            )
          }
          style={{
            fontSize: "14px",
            width: "100%",
            backgroundColor: "white",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #2196f3"
          }}
        >
          Download
        </button>
        {// check if the value is a date -> for old files completed this will be a displayname string in format [typecode]: '...'
        isDate(candidate.documents.readings.NPDC) ? (
          <div className="tooltiptext">
            Signed {formatTimestamp(candidate.documents.readings.NPDC)}
          </div>
        ) : null}
      </div>
    ) : (
      <div className="tw-w-full tw-flex tw-justify-center">
        <TodoIcon />
      </div>
    );

  /**
   * Retrieves only RTW files from candidate files.
   * @param {Object} candidate
   * @returns {Array<Array<string, string>} Array of Array [[typecode, title], [...]]
   */
  const candidateHasRTWDocs = candidate => {
    let rtwOnly = [];
    if (candidate.documents && candidate.documents.readings) {
      const entries = Object.entries(candidate.documents.readings);
      // if(candidate.documents && candidate.documets.readings) console.log( candidate.documets.readings)
      rtwOnly = entries.filter(row => {
        const [typeCode] = row;
        return typeCode !== PECAN_TYPE_CODES[0]
          ? PECAN_TYPE_CODES.includes(typeCode)
          : false;
      });
    }
    return rtwOnly;
  };

  /**
   * Return the correct content type for file
   * @param {String} ext
   * @returns {String}
   */
  const getContentType = ext => {
    if (ext === ".docx")
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    if (ext === ".pdf") return "application/pdf";
    return "image/jpg";
  };

  /**
   * Remove any illegal character(s) (e.g. -) which can prevent downloads when downloading files to a users computer
   */
  const cleanFilename = filename => filename.replace(/\W+/g, " ");

  /**
   * Return the dropdown of candidate RTW files (if) avaliable for download or red cross icon.
   * @param {Object} candidate
   * @returns JSX
   */
  const RTWDocs = candidate => {
    const rtwDocs = candidateHasRTWDocs(candidate);
    if (rtwDocs.length > 0) {
      return (
        <div className="tw-w-full tw-flex tw-justify-center">
          <Menu
            style={{ width: "100%" }}
            as="div"
            className="tw-relative tw-inline-block sm:tw-pl-2 tw-text-left"
          >
            <Menu.Button
              style={{ border: "1px solid #2196f3" }}
              className="tw-flex tw-justify-center tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-p-2 tw-bg-white tw-text-sm tw-text-gray-700 "
            >
              RTW Downloads
              <ChevronDownIcon
                className="tw--mr-1 tw-ml-2 tw-h-5 tw-w-5"
                aria-hidden="true"
              />
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="tw-transition tw-ease-out tw-duration-100"
              enterFrom="tw-transform tw-opacity-0 tw-scale-95"
              enterTo="tw-transform tw-opacity-100 tw-scale-100"
              leave="tw-transition tw-ease-in tw-duration-75"
              leaveFrom="tw-transform tw-opacity-100 tw-scale-100"
              leaveTo="tw-transform tw-opacity-0 tw-scale-95"
            >
              <Menu.Items className=" tw-origin-top-right tw-relative tw-w-full tw-right-0 tw-mt-2 tw-w-36 tw-rounded-md tw-shadow-lg tw-bg-white tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-focus:outline-none">
                <div className="tw-py-1">
                  {rtwDocs.map(row => {
                    const [typeCode, title] = row;
                    const ext = typeCodeToExt.get(typeCode);
                    return (
                      <Menu.Item key={typeCode}>
                        {({ active }) => (
                          <div
                            // Set correct file ext + MIME type for RTW content
                            onClick={() =>
                              handleDownloadReadingList(
                                candidate,
                                typeCode,
                                cleanFilename(title),
                                getContentType(ext),
                                ext
                              )
                            }
                            href="#"
                            className={`${
                              active
                                ? "tw-bg-gray-100 tw-text-gray-900 tw-no-underline"
                                : "tw-no-underline tw-text-gray-700"
                            }
                              tw-block tw-px-4 tw-py-2 tw-text-sm tw-no-underline tw-cursor-pointer `}
                          >
                            {title}
                          </div>
                        )}
                      </Menu.Item>
                    );
                  })}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      );
    }
    return (
      <div className="tw-w-full tw-flex tw-justify-center">
        <TodoIcon />
      </div>
    );
  };

  return (
    <div className="md:tw-flex tw-hidden md:tw-flex-col">
      <div className="tw-rounded-md tw-overflow-x-auto sm:tw--mx-6">
        <div className="tw-align-middle tw-rounded-md tw-inline-block tw-min-w-full sm:tw-px-6 lg:tw-px-8">
          <div className="tw-shadow tw-rounded-md tw-overflow-hidden tw-border-b tw-border-gray-200 tw-sm:rounded-lg">
            <table className="tw-min-w-full tw-border-2 tw-border-gray-500 tw-rounded-md tw-mb-8 tw-divide-y tw-divide-gray-200">
              <thead className="tw-bg-gray-50 tw-rounded-md tw-border-2 tw-border-gray-500 ">
                <tr>
                  <th
                    scope="tw-col"
                    style={{ width: "12%" }}
                    className="tw-py-4 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center tw-tracking-wider"
                  >
                    Worker
                  </th>
                  <th
                    scope="col"
                    style={{ width: "11%" }}
                    className="tw-py-4 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center tw-tracking-wider"
                  >
                    Induction Pack
                  </th>
                  <th
                    scope="col"
                    style={{ width: "11%" }}
                    className="tw-py-4 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center tw-tracking-wider"
                  >
                    Right to Work Documents
                  </th>
                </tr>
              </thead>
              <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
                {candidates.map((c, i) => (
                  <tr className="reading-list__rows" key={i * 100}>
                    <td className="tw-text-sm">
                      <div className="tw-flex tw-w-full tw-items-center">
                        {images && images[c.candidateRef] ? (
                          <CandImage
                            handleOverlay={handleOverlay}
                            passImage={passImage}
                            image={images[c.candidateRef]}
                            firstName={c.firstName}
                          />
                        ) : (
                          <div className="tw-w-20 tw-h-20 tw-m-1 tw-mx-2 tw-mr-3 tw-cursor-pointer ">
                            <div className="tw-bg-gray-200 tw-flex tw-justify-center tw-items-center tw-text-lg tw-h-full tw-w-full hover:tw-border-yellow-300 tw-rounded-full tw-border-2 tw-border-gray-400 tw-shadow-sm">
                              {c.firstName[0]}
                              {c.lastName[0]}
                            </div>
                          </div>
                        )}
                        <p className="tw-font-bold tw-font-lg">
                          {c.firstName} {c.lastName}
                        </p>
                      </div>
                    </td>

                    <td className="tw-p-2"> {isRead(c)} </td>
                    <td className="tw-p-2"> {RTWDocs(c)} </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <a className="d-none" ref={downloadRef}></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PecanDeluxe;
